import {
  ButtonContainer,
  CloseDrawerIcon,
  Drawer,
  DrawerTitleContainer,
  SideDrawerList,
  SideDrawerListItem,
} from 'components/layout/SideDrawer/components';

import BrandLogo from 'components/layout/BrandLogo';
import { Link } from 'react-router-dom';
import { Spin } from 'antd';
import { StartApplicationForm } from 'components/forms/StartApplicationForm';
import useURLs from 'hooks/use-url';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export default function SideDrawer(props: Props): JSX.Element {
  const { isOpen, setIsOpen } = props;
  const urls = useURLs();

  if (!urls) {
    return <Spin />;
  }

  return (
    <Drawer
      title={
        <DrawerTitleContainer>
          <CloseDrawerIcon size={20} onClick={() => setIsOpen(false)} />
          <BrandLogo />
        </DrawerTitleContainer>
      }
      width='85%'
      placement='left'
      closable={false}
      onClose={() => setIsOpen(false)}
      open={isOpen}
    >
      <SideDrawerList>
        <SideDrawerListItem>
          <Link to='/help' onClick={() => setIsOpen(false)}>
            Help
          </Link>
        </SideDrawerListItem>
        <ButtonContainer>
          <StartApplicationForm endpoint={urls.apply.url} buttonHeight={44} />
        </ButtonContainer>
      </SideDrawerList>
    </Drawer>
  );
}
